import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Form } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { ADDRESS, ALLOWED_DOMAINS } from 'constants/index'
import { conversationAddressAct } from 'redux_new/actions'
import { composerAct } from 'redux/actions'
import { apiUsers } from 'api'
import allowedDomains from 'constants/allowed-domains'
import TextInputField from 'components/Form/TextInputField'
import { Button as ButtonForm, PhoneInput } from 'components/Form'
import es from 'react-phone-input-2/lang/es.json'
import ModalWrapper from 'components/ModalWrapper'

const lang = (text) => I18n.t(text)

const validateErrors = (address) => {
  const errors = {}

  if (ALLOWED_DOMAINS.type !== 'OP') {
    Object.keys(ADDRESS.addressSchema).forEach((prop) => {
      if (!address[prop]) {
        errors[prop] = true
      }
    })
  }

  return Object.keys(errors).length > 0 ? errors : false
}

const AddressModal = ({ currentAddress, showModal, onCloseModal, userId }) => {
  const [address, setAddress] = useState({ ...ADDRESS.addressSchema })
  const [errors, setErrors] = useState({})
  const [numberToSendSMS, setNumberToSendSMS] = useState('')

  const dispatch = useDispatch()


  useEffect(() => {
    setAddress({ ...ADDRESS.addressSchema, ...(currentAddress || {}) })
    setErrors({})
    getContactInfo()
  }, [currentAddress])

  const onChange = (field, value) => {
    if (field === 'countryPhone') {
      const { country, dialCode, phoneValidate } = value
      setAddress({ ...address, 'country': country.toUpperCase(), 'dialCode': dialCode, 'telephone': phoneValidate })
    } else setAddress({ ...address, [field]: value })
  }

  const getContactInfo = async () => {
    try {
      let dialCode = ''
      if (currentAddress?.dialCode) {
        dialCode = currentAddress.dialCode.substr(0, 1) === '+'
          ? currentAddress.dialCode
          : `+${currentAddress.dialCode}`
      }

      if (currentAddress?.telephone) {
        setNumberToSendSMS(`${dialCode}${currentAddress.telephone}`)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const onSubmit = async () => {
    try {
      const newErrors = validateErrors(address)
      if (newErrors) {
        setErrors(newErrors)
      } else {
        await dispatch(conversationAddressAct.set(address))

        onCloseModal()
      }
    } catch(error) {
      console.error(error)
    }
  }

  const onCreateLink = async () => {
    try {
      const { data: { result } } = await apiUsers.passengers.getWebviewLink(userId)
      await dispatch(composerAct.addExternalText(`${I18n.t('messages_webviewLink')}▶️ ${result} ◀️`))
      onCloseModal()

    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ModalWrapper
      id={'modalEditAddress'}
      showClose
      isOpen={showModal}
      toggle={onCloseModal}
      header={I18n.t(!currentAddress ? 'dashboard_add-address' : 'dashboard_edit-address')}
      body={
        <Form className='edit' >
          <TextInputField
            label={lang('dashboard_email')}
            type='email'
            name='email'
            value={address.email}
            placeholder={lang('dashboard_email')}
            onChange={(value) => onChange('email', value)}
            errorMessage={errors.email && lang('dashboard_errors_required-field')}
          />
          <TextInputField
            label={lang('dashboard_street')}
            name='street'
            value={address.street}
            placeholder={lang('dashboard_street')}
            onChange={(value) => onChange('street', value)}
            errorMessage={errors.street && lang('dashboard_errors_required-field')}
          />
          <TextInputField
            label={lang('dashboard_postal-code')}
            name={'postcode'}
            value={address.postcode}
            placeholder={lang('dashboard_postal-code')}
            onChange={(value) => onChange('postcode', value)}
            errorMessage={errors.postcode && lang('dashboard_errors_required-field')}
          />
          <TextInputField
            label={lang('dashboard_city')}
            name={'city'}
            value={address.city}
            placeholder={lang('dashboard_city')}
            onChange={(value) => onChange('city', value)}
            errorMessage={errors.city && lang('dashboard_errors_required-field')}
          />
          <TextInputField
            label={lang('dashboard_province')}
            name={'province'}
            value={address.province}
            placeholder={lang('dashboard_province')}
            onChange={(value) => onChange('province', value)}
            errorMessage={errors.province && lang('dashboard_errors_required-field')}
          />
          <div >
            <label className='text-input-label'>{lang('dashboard_phone')}</label>
            <PhoneInput
              id='user_phone'
              localization={address.country.toLowerCase()}
              buttonClass='code_phone_btn'
              country={es}
              autoFormat
              enableSearch
              value={numberToSendSMS}
              onChange={(value) => onChange('countryPhone', value)}
            />
            {errors.telephone &&
              <span className='text-input-error-message'>{`${lang('dashboard_errors_required-field')} `}</span>
            }
          </div>
        </Form>
      }
      footer={
        <>

          <div className='footer-buttons-wrapper'>
            <ButtonForm secondary onClick={onSubmit}>
              {I18n.t('dashboard_save')}
            </ButtonForm>
            <ButtonForm onClick={onCloseModal}>
              {I18n.t('dashboard_cancel')}
            </ButtonForm>
            {
              allowedDomains.type !== 'OP' && (
                <ButtonForm primary onClick={onCreateLink}>
                  {I18n.t('dashboard_create-link')}
                </ButtonForm>
              )
            }
          </div>
        </>

      }
    />
  )
}

export default AddressModal
